import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import * as actions from '../../actions/event_edit'

export class EventDelete extends Component {
  constructor(props) {
    super(props)
    this.state = {eventName: ''}

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.props.getEvent(this.props.params.id).then(() => {
      this.setState({eventName: this.props.event.name})
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.props.deleteEvent(this.props.params.id)
  }

  render() {
    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      return (
        <div>
          <form onSubmit={this.handleSubmit}>
            <div className="float-xs-right">
              <button action="submit" className="btn btn-danger">DELETE</button>
            </div>
            <h1>{this.state.eventName}</h1>
            <input
              type="hidden"
              name="eventName"
              value={this.state.eventName}
            />
            <p>Are you sure you want to delete this event?</p>
          </form>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    event: state.event.item,
    loading: state.event.loading,
  }
}

export default connect(mapStateToProps, actions)(EventDelete)



/** WEBPACK FOOTER **
 ** ./src/components/events/delete.js
 **/